import React, { useState, useEffect } from 'react';
import { getLogoUrl } from '../services/logoService';

/**
 * AppLogo component with admin upload support
 */
function AppLogo() {
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadLogo = async () => {
      try {
        console.log('AppLogo: Attempting to load logo...');
        const url = await getLogoUrl();
        console.log('AppLogo: Received logo URL:', url);
        setLogoUrl(url);
      } catch (error) {
        console.error('AppLogo: Error loading logo:', error);
      } finally {
        setLoading(false);
      }
    };

    loadLogo();
    
    // Listen for logo update events
    const handleLogoUpdate = () => {
      console.log('AppLogo: Logo update event received');
      loadLogo();
    };
    
    window.addEventListener('logoUpdated', handleLogoUpdate);
    
    return () => {
      window.removeEventListener('logoUpdated', handleLogoUpdate);
    };
  }, []);

  return (
    <div
      style={{
        position: 'absolute',
        top: '5px',
        left: '5px',
        zIndex: 9999
      }}
    >
      {loading ? (
        <div
          style={{
            width: '150px',
            height: '40px',
            backgroundColor: '#333',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          LOGO
        </div>
      ) : logoUrl ? (
        <img
          src={logoUrl}
          alt="App Logo"
          style={{
            height: '40px',
            width: 'auto',
            display: 'block'
          }}
          onError={(e) => {
            console.error('Error loading logo image');
            e.target.style.display = 'none';
          }}
        />
      ) : (
        <div
          style={{
            width: '150px',
            height: '40px',
            backgroundColor: '#333',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          LOGO
        </div>
      )}
    </div>
  );
}

export default AppLogo;